// What's New — РЕАЛЬНЫЕ релиз-ноты (дизайн v8, июль 2026). Обновляется
// вручную при заметных релизах: бампни RELEASE_VERSION, чтобы модалка
// показалась каждому по разу (AppLayout сравнивает с localStorage SEEN_KEY).
// Прошлые релизы копятся в PREVIOUS_RELEASES (пока пусто — история нот
// начинается с этого релиза; кнопка чейнджлога скрыта, пока список пуст).

/** Bumping this re-arms the once-per-release auto-show. Drives the header chip. */
export const RELEASE_VERSION = 'July 2026'

/** localStorage key holding the last version the user dismissed. */
export const SEEN_KEY = 'wt:whatsnew:seen'

/** Which built-in illustration a slide renders (full preview + small thumb). */
export type SlideMedia = 'chart' | 'columns' | 'bars' | 'rewards'

/** Which feature glyph sits in the slide's media pill. */
export type SlideIcon = 'bolt' | 'pulse' | 'portfolio' | 'gift'

export interface WhatsNewSlide {
  /** media pill label */
  pill: string
  icon: SlideIcon
  media: SlideMedia
  title: string
  body: string
}

export interface Release {
  /** header chip text (calendar tag, not a made-up semver). */
  version: string
  date: string
  // Non-empty tuple so slides[0] is a sound fallback under noUncheckedIndexedAccess.
  slides: [WhatsNewSlide, ...WhatsNewSlide[]]
}

export const CURRENT_RELEASE: Release = {
  version: RELEASE_VERSION,
  date: 'July 7',
  slides: [
    {
      pill: 'New look',
      icon: 'bolt',
      media: 'columns',
      title: 'A calmer, sharper terminal',
      body: 'Graphite surfaces, zoned buy/sell colours and role-based hairlines across Discover, Pulse, search and the token page.',
    },
    {
      pill: 'Activity windows',
      icon: 'pulse',
      media: 'bars',
      title: 'Activity from 5m to 24h',
      body: 'Hover the activity strip on a token to switch 5m / 1h / 6h / 24h windows — volumes and buy/sell counts are computed on-chain, server-side.',
    },
    {
      pill: 'Limit orders UI',
      icon: 'portfolio',
      media: 'chart',
      title: 'Limit targets on the real mcap',
      body: 'The limit form seeds from the live market cap with a −100…+200% slider — the trade button reads your exact target.',
    },
    {
      pill: 'Instant Trade',
      icon: 'bolt',
      media: 'rewards',
      title: 'A lighter Instant Trade',
      body: 'The floating quick-trade panel was rebuilt: editable buy amounts, sell percents and the same trade settings as the side panel.',
    },
  ],
}

export const PREVIOUS_RELEASES: Release[] = []
